// Persistencia de sesión en localStorage (equivalente a AUTH_PARAMS / LOCACION_SELECCIONADA
// del front AngularJS de Qualita).
const KEY = 'DPY_AGIL_AUTH'

export function getStoredAuth() {
  try {
    const raw = localStorage.getItem(KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function setStoredAuth(auth) {
  localStorage.setItem(KEY, JSON.stringify(auth))
}

export function clearStoredAuth() {
  localStorage.removeItem(KEY)
}
